import React, { ReactNode, useState, useCallback } from 'react';
import { APIData, ChangeData, ErrorResponse, RegionMetadata } from '../services/model';

export const sorting = {
    asc: 'asc',
    desc: 'desc',
};

type State = {
    isInternal: boolean | undefined;
    apis?: APIData[];
    changes?: ChangeData[];
    regions?: RegionMetadata[];
    error?: ErrorResponse;
    openApiSpec: object | undefined;
    filter?: string;
    sort?: string;
};

const initialState: State = {
    isInternal: undefined,
    apis: undefined,
    changes: undefined,
    regions: undefined,
    error: undefined,
    openApiSpec: undefined,
    filter: undefined,
    sort: sorting.asc,
};

export const Store = React.createContext<State>(initialState);

export const StoreState: { set: (state: Partial<State>) => void } = { set: () => undefined };

export type StoreProviderProps = { children: ReactNode };
export const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
    const [state, setState] = useState<State>(initialState);

    StoreState.set = useCallback((updates: Partial<State>) => {
        setState((prev) => ({ ...prev, ...updates }));
    }, []);

    return <Store.Provider value={state}>{children}</Store.Provider>;
};
